import { put, takeEvery, call, select } from "redux-saga/effects";
import * as actionTypes from "./constants";
import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import * as actionTypes2 from "../TripDesignCrudContainer/constants";

function* commonFunction(value) {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${value.api}`, {
      method: `${value.method}`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: value.body ? value.body : null,
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: `${value.sucessAction}`,
        payload: resJSON,
      });
      if (value.sucessAction === actionTypes.FETCH_LOAD_SUCCESS_ACTION) {
        // yield put({
        //   type: actionTypes2.CLEAR_SELECTED_LIST,
        // })
      }
    }
  } catch (err) {
    console.error("error", err);
    if (err.ok === false) {
      yield put({ type: `${value.failAction}`, error: err });
    } else {
    }
  }
}

function* getPaymentMode() {
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(`${appConfig.ip}/paymentMode?type=load`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: actionTypes.GET_PAYMODE_SUCCESS,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: actionTypes.GET_PAYMODE_FAIL, error: err });
    } else {
    }
  }
}

function* fetchLoadData(value) {
  console.log(value);
  let user = JSON.parse(localStorage.getItem("user"));

  try {
    let page = (value.params && value.params.page) || 1;
    let ser = (value.params && value.params.search) || "";
    let selectedTab = "";
    if (value.params.filter) {
      selectedTab = value.params.filter;
    } else {
      if (value.params && value.params.selectedTab) {
        selectedTab =
          value.params.selectedTab === "planned"
            ? "planned"
            : value.params.selectedTab === "created"
              ? "created,pending"
              : value.params.selectedTab === "rejected"
                ? "rejected,cancelled"
                : "bid";
      } else {
        selectedTab = "created,pending";
      }
    }

    // let selectedTab = value.params.selectedTab;

    let apiTripPlan = `${appConfig.ip}/tripPlan?orgId=${user.orgId}&limit=10&page=${page}&ser=${ser}`;

    let params = {
      page: page,
      api:
        selectedTab === "planned"
          ? apiTripPlan
          : `${appConfig.ip}/loadData?status=${selectedTab ? selectedTab : "created,pending"
          }&limit=10&page=${page}&ser=${ser}&runnerOrgId=${user.orgId
          }&sort=pickupDate`,
      method: "GET",
      sucessAction: actionTypes.FETCH_LOAD_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_LOAD_FAIL_ACTION,
      body: null,
    };

    yield call(commonFunction, params);
  } catch (e) {
    console.error(e);
  }
}

function* fetchTripDesignLoadDataid(value) {
  let id = value.value;
  try {
    // let page = (value.params && value.params.page) || 1;
    let params = {
      // page: page,
      api: `${appConfig.ip}/loadData/${id}`,
      method: "GET",
      sucessAction: actionTypes.FETCH_LOAD_ID_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_LOAD_ID_FAIL_ACTION,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error("===============");
  }
}

function* fetchSubscriptnLog(value) {
  let id = value.value;
  try {
    // let page = (value.params && value.params.page) || 1;
    let params = {
      // page: page,
      api: `${appConfig.ip}/subscriptionlog?loadId=${id}`,
      method: "GET",
      sucessAction: actionTypes.FETCH_SUBLOG_SUCCESS_ACTION,
      failAction: actionTypes.FETCH_SUBLOG_FAIL_ACTION,
      body: null,
    };
    yield call(commonFunction, params);
  } catch (e) {
    console.error("===============");
  }
}

// function* fetchDriverData(value) {
//   try {
//     let params = {
//       api: `${appConfig.ip}/dProf/users?limit=10`,

//       method: "GET",
//       sucessAction: actionTypes.FETCH_LOAD_DRIVER_SUCCESS_ACTION,
//       failAction: actionTypes.FETCH_LOAD_DRIVER_FAIL_ACTION,
//       body: null,
//     };
//     yield call(commonFunction, params);
//   } catch (e) {
//     console.error(e);
//   }
// }

// function* fetchVehicleData(value) {
//   try {
//     let params = {
//       api: `${appConfig.ip}/vehicleInvntry?status=active`,
//       method: "GET",
//       sucessAction: actionTypes.FETCH_LOAD_VEHICLE_SUCCESS_ACTION,
//       failAction: actionTypes.FETCH_LOAD_VEHICLE_FAIL_ACTION,
//       body: null,
//     };
//     yield call(commonFunction, params);
//   } catch (e) {
//     console.error(e);
//   }
// }

function* rejectLoad(value) {
  console.log(value);
  const token = localStorage.getItem("token");
  let user = JSON.parse(localStorage.getItem("user"));
  console.log(user);

  let loadID = value.value.id;

  const state = yield select(); //to fetch the reducer value
  const bidPayMode = state.loadReducer.bidPayMode;
  const codPayMode = state.loadReducer.codPayMode;
  const subscriptionPayMode = state.loadReducer.subscriptionPayMode;

  console.log(bidPayMode);
  console.log(codPayMode);
  console.log(subscriptionPayMode);

  const loadDetails = {
    status: "rejected",
    paymntStatus: "cancelled",
  };

  const invoiceBody = {
    status: "canceld",
    creator: value.value.runner,
    reciever: user.id,
    amount: value.value.amount,
    currency: value.value.currency,
  };

  const payBody = {
    status: "cancelled",
  };

  if (value.value.paymntStatus === "not paid") {
    if (value.value.payMode === bidPayMode[0].id) {
      try {
        const res = yield fetch(
          `${appConfig.ip}/loadData/updateLoad/${loadID}`,
          {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(loadDetails),
          }
        );

        if (!res.ok) {
          throw res;
        } else {
          const resJSON = yield res.json();
          yield put({
            type: actionTypes.REJECT_LOAD_SUCCESS,
            payload: resJSON,
          });

          yield put({
            type: actionTypes.FETCH_LOAD_INIT_ACTION,
            params: { page: 1, selectedTab: "created" },
            //payload: { status: "created,pending" },
          });

          yield toast.info("You have succesfully rejected the selected load", {
            autoClose: 3000,
            className: "toastClass",
          });
        }
      } catch (err) {
        if (err.ok === false) {
          yield put({ type: actionTypes.REJECT_LOAD_FAIL, error: err });
        } else {
        }
      }
    } else {
      try {
        const res = yield fetch(
          `${appConfig.ip}/loadData/updateLoad/${loadID}`,
          {
            method: "PUT",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(loadDetails),
          }
        );

        if (!res.ok) {
          throw res;
        } else {
          const resJSON = yield res.json();
          try {
            const resInvoice = yield fetch(
              `${appConfig.ip}/invoice?loadId=${loadID}`,
              {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            if (!resInvoice.ok) {
              throw resInvoice;
            } else {
              const resInvoiceJSON = yield resInvoice.json();
              const invoiceID = resInvoiceJSON.rows[0].id;

              try {
                const res1 = yield fetch(
                  `${appConfig.ip}/invoice/${invoiceID}`,
                  {
                    method: "PUT",
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(invoiceBody),
                  }
                );

                if (!res1.ok) {
                  throw res1;
                } else {
                  yield put({
                    type: actionTypes.REJECT_LOAD_SUCCESS,
                    payload: resJSON,
                  });
                  yield put({
                    type: actionTypes.FETCH_LOAD_INIT_ACTION,
                    params: { page: 1, selectedTab: "created" },
                    //payload: { status: "created,pending" },
                  });
                  yield toast.info(
                    "You have succesfully rejected the selected load",
                    {
                      autoClose: 3000,
                      className: "toastClass",
                    }
                  );
                }
              } catch (err) {
                if (err.ok === false) {
                  console.log("Invoice not cancelled");
                } else {
                }
              }
            }
          } catch (err) { }
        }
      } catch (err) {
        if (err.ok === false) {
          yield put({ type: actionTypes.REJECT_LOAD_FAIL, error: err });
        } else {
        }
      }
    }
  } else {
    try {
      const res = yield fetch(`${appConfig.ip}/loadData/updateLoad/${loadID}`, {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(loadDetails),
      });

      if (!res.ok) {
        throw res;
      } else {
        const resJSON = yield res.json();
        try {
          const resInvoice = yield fetch(
            `${appConfig.ip}/invoice?loadId=${loadID}`,
            {
              method: "GET",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (!resInvoice.ok) {
            throw resInvoice;
          } else {
            const resInvoiceJSON = yield resInvoice.json();
            const invoiceID = resInvoiceJSON.rows[0].id;

            try {
              const res1 = yield fetch(`${appConfig.ip}/invoice/${invoiceID}`, {
                method: "PUT",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(invoiceBody),
              });

              if (!res1.ok) {
                throw res1;
              } else {
                try {
                  const resPay = yield fetch(
                    `${appConfig.ip}/payment?loadId=${loadID}`,
                    {
                      method: "GET",
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  );

                  if (!resPay.ok) {
                    throw resPay;
                  } else {
                    const resPayJSON = yield resPay.json();
                    const payID = resPayJSON.rows[0].id;

                    try {
                      const res2 = yield fetch(
                        `${appConfig.ip}/payment/${payID}`,
                        {
                          method: "PUT",
                          headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                          },
                          body: JSON.stringify(payBody),
                        }
                      );

                      if (!res2.ok) {
                        throw res2;
                      } else {
                        const subRevision = {
                          loadId: value.value.id,
                        };

                        const cancelRequest = {
                          status: "created",
                          invoiceId: resInvoiceJSON.rows[0].id,
                          paymentId: resPayJSON.rows[0].id,
                          paymentMode: value.value.payMode,
                          loadId: value.value.id,
                          orgId: user.orgId,
                        };
                        if (value.value.payMode === subscriptionPayMode[0].id) {
                          try {
                            const ressubRevise = yield fetch(
                              `${appConfig.ip}/subscriptn/cancelLoad`,
                              {
                                method: "POST",
                                headers: {
                                  Accept: "application/json",
                                  "Content-Type": "application/json",
                                  Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify(subRevision),
                              }
                            );

                            if (!ressubRevise.ok) {
                              throw ressubRevise;
                            } else {
                              yield put({
                                type: actionTypes.REJECT_LOAD_SUCCESS,
                                payload: resJSON,
                              });
                              yield put({
                                type: actionTypes.FETCH_LOAD_INIT_ACTION,
                                params: { page: 1, selectedTab: "created" },
                                //payload: { status: "created,pending" },
                              });
                              yield toast.info(
                                "You have succesfully rejected the selected load",
                                {
                                  autoClose: 3000,
                                  className: "toastClass",
                                }
                              );
                            }
                          } catch (err) {
                            console.log("Subscription revision not done");
                          }
                        } else {
                          try {
                            const resCanclRqst = yield fetch(
                              `${appConfig.ip}/cancellationRqst`,
                              {
                                method: "POST",
                                headers: {
                                  Accept: "application/json",
                                  "Content-Type": "application/json",
                                  Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify(cancelRequest),
                              }
                            );

                            if (!resCanclRqst.ok) {
                              throw resCanclRqst;
                            } else {
                              yield put({
                                type: actionTypes.REJECT_LOAD_SUCCESS,
                                payload: resJSON,
                              });
                              yield put({
                                type: actionTypes.FETCH_LOAD_INIT_ACTION,
                                params: { page: 1, selectedTab: "created" },
                                //payload: { status: "created,pending" },
                              });
                              yield toast.info(
                                "You have succesfully rejected the load and the created invoice has been cancelled. A request for payment cancellation is sent to the Admin",
                                {
                                  autoClose: 3000,
                                  className: "toastClass",
                                }
                              );
                            }
                          } catch (err) {
                            console.log(
                              "Payment cancellation request not sent!!"
                            );
                          }
                        }
                      }
                    } catch (err) {
                      if (err.ok === false) {
                        console.log("Payment not cancelled");
                      } else {
                      }
                    }
                  }
                } catch (err) {
                  if (err.ok === false) {
                    console.log("Cannot fetch the payment");
                  } else {
                  }
                }
              }
            } catch (err) {
              console.log("Cannot update the invoice status to cancelled");
            }
          }
        } catch (err) {
          console.log("Cannot fetch the invoice");
        }
      }
    } catch (err) {
      if (err.ok === false) {
        yield put({ type: actionTypes.REJECT_LOAD_FAIL, error: err });
      } else {
      }
    }
  }
}

export function* tripDesignActionWatcher() {
  yield takeEvery(actionTypes.FETCH_LOAD_INIT_ACTION, fetchLoadData);
  yield takeEvery(
    actionTypes.FETCH_LOAD_ID_INIT_ACTION,
    fetchTripDesignLoadDataid
  );
  yield takeEvery(actionTypes.FETCH_SUBLOG_INIT_ACTION, fetchSubscriptnLog);
  yield takeEvery(actionTypes.REJECT_LOAD_INIT, rejectLoad);
  yield takeEvery(actionTypes.GET_PAYMODE_INIT, getPaymentMode);
  // yield takeEvery(actionTypes.FETCH_LOAD_DRIVER_INIT_ACTION, fetchDriverData);
  // yield takeEvery(actionTypes.FETCH_LOAD_VEHICLE_INIT_ACTION, fetchVehicleData);
}
